<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 5H5V19H10V21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H9.18C9.6 1.84 10.7 1 12 1C13.3 1 14.4 1.84 14.82 3H19C20.1 3 21 3.9 21 5V10H19V5H17V6C17 7.1 16.1 8 15 8H9C7.9 8 7 7.1 7 6V5ZM13 4C13 3.45 12.55 3 12 3C11.45 3 11 3.45 11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4ZM20.3002 18.9L22.3002 20.9C22.6902 21.29 22.6802 21.92 22.2902 22.31C21.9002 22.7 21.2802 22.7 20.8902 22.31L18.8902 20.31C17.8802 20.89 16.6702 21.26 15.2402 20.82C13.5202 20.29 12.2002 18.77 12.0202 16.98C11.7402 14.1 14.1002 11.75 16.9702 12.03C18.7702 12.2 20.2802 13.53 20.8102 15.25C21.2502 16.67 20.8802 17.89 20.3002 18.9ZM14.0002 16.5C14.0002 17.9 15.1002 19 16.5002 19C17.9002 19 19.0002 17.9 19.0002 16.5C19.0002 15.1 17.9002 14 16.5002 14C15.1002 14 14.0002 15.1 14.0002 16.5Z"
    fill="currentColor"
  />
</svg>
